import type { OnPageTransitionEndSync } from "vike/types";

// Fires only on client-side (soft) navigation, after the new page has rendered —
// never on the initial document load (that page_view is written server-side).
// Bridges to the initialized standalone tracker instance (loaded via /tracking.js)
// through a window global, so we don't pull in a second, uninitialized copy of
// the tracking module. See server/lib/ssr-pageview.ts for the SSR-side counterpart.
export const onPageTransitionEnd: OnPageTransitionEndSync = (): void => {
  if (typeof window === "undefined") return;
  (window as { __lcTrackPageView?: () => void }).__lcTrackPageView?.();
};
